import angular from 'angular';
import { InputEmailValidator as validator } from './input-email.validator';

/**
 * This validator overrides the default angular <input type="email" /> validation
 * with a custom regex that matches our current validation in the Updater API
 */
export const InputEmailValidator = angular
  .module('angular-common.validators.input-email', [])
  .directive('input', validator);
